import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { grpAuthStateSelector } from '../../../redux/selectors/e3DGrpAuthSelectors'

type ContextType = {
    reinitCounter: number
    triggerReinit: () => void
}

const E3DReinitContext = createContext<ContextType | undefined>(undefined)

export const E3DReinitProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [reinitCounter, setReinitCounter] = useState(0)
    const e3DAuthState = useSelector(grpAuthStateSelector)

    const triggerReinit = useCallback(() => {
        setReinitCounter((prev) => prev + 1)
        // eslint-disable-next-line
    }, [setReinitCounter, e3DAuthState])

    useEffect(() => {
        (window as any).__e3dReinitCallback = triggerReinit
        return () => {
            delete (window as any).__e3dReinitCallback
        }
    }, [triggerReinit])

    return (
        <E3DReinitContext.Provider value={{ reinitCounter, triggerReinit }}>
            {children}
        </E3DReinitContext.Provider>
    )
}

export const useE3DReinit = () => {
    const context = useContext(E3DReinitContext)

    if (!context) {
        return {
            reinitCounter: 0,
            triggerReinit: () => {},
        }
    }

    return context
}
